import ResourcesGroup from './ResourcesGroup'

export default ResourcesGroup
